export default {
  _enterCredentials: 'no AdminDigital',
  _securityFooter: 'da Núcleo P',
  exTitle: 'Conectando Oportunidades',
  subtitle: 'Soluções digitais para organizar relacionamentos comerciais, identificar novas oportunidades e administrar sua presença digital.',
  secureAccessTitle: 'Acesso Seguro',
  secureAccessBody: 'Seus dados protegidos com criptografia e as melhores práticas de segurança.',
  orgCentralTitle: 'Inteligência Comercial',
  orgCentralBody: 'Organize contatos e oportunidades no CRM e descubra empresas com potencial de negócio através do Scanner.',
  quickEntryTitle: 'Sua Presença Digital',
  quickEntryBody: 'Administre seu site pelo WebAdmin, com autonomia para manter suas informações sempre atualizadas.',
  reliability: 'Plataforma confiável utilizada por empresas que buscam eficiência e resultados.',
  product: 'AdminDigital',
};
